import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { fetchOrderHistory } from 'Store/User/thunks';
import OrderHistoryPage from 'Pages/OrderHistoryPage/OrderHistoryPage';

import { 
  getIsLoggedIn, 
  getIsFetchingOrders, 
  getSortedOrderHistory, 
  getIsFetchingUser,
} from 'Store/User/selectors';

interface IPropsInternal {
  isLoggedIn: boolean;
  isFetchingOrderHistory: boolean;
  isFetchingUserLogin: boolean;
  orderHistory: Julius.Website.OrderSmallViewModel[];
  fetchOrderHistory: () => void;
}

type Props = IPropsInternal & RouteComponentProps<{}>;

class OrderHistoryPageContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchOrderHistory();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!this.props.isLoggedIn && nextProps.isLoggedIn) {
      this.props.fetchOrderHistory();
    }
  }

  onBack = () => {
    this.props.history.replace('/');
  }

  onContact = () => {
    this.props.history.push('/information/kontakt');
  }

  render() {
    return (
      <OrderHistoryPage 
        isLoggedIn={ this.props.isLoggedIn }
        isFetching={ this.props.isFetchingOrderHistory || this.props.isFetchingUserLogin } 
        orderHistory={ this.props.orderHistory }
        onBack={ this.onBack } 
        onQuestions={ this.onContact } 
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isLoggedIn: getIsLoggedIn(state),
    isFetchingOrderHistory: getIsFetchingOrders(state),
    isFetchingUserLogin: getIsFetchingUser(state),
    orderHistory: getSortedOrderHistory(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchOrderHistory,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderHistoryPageContainer);


// WEBPACK FOOTER //
// ./src/pages/OrderHistoryPage/OrderHistoryPageContainer.tsx